function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class annotationActionCreators.
 *
 */
import { createHashHistory } from 'history';
import * as ajax from './ajax';
import reportAnnotationConstants from '../constants/reportAnnotationConstants';
import changeActionFactory from './factories/changeActionFactory';
import tokenErrorActions from './tokenErrorActionCreators';
import issueActions from './issueActionCreators';
import issueConstants from '../constants/issueConstants';
const changeActions = changeActionFactory('reportAnnotation', 'reportAnnotations');
const hashHistory = createHashHistory();
const showCancel = () => ({
  type: issueConstants.SHOW_CANCEL
});
const handleRedirect = dispatch => {
  dispatch(showCancel());
  hashHistory.goBack();
};
const createAnnotations = (annotation, type) => ({
  type: reportAnnotationConstants[`CREATE_${type.toUpperCase()}`],
  annotation
});
const reset = () => ({
  type: reportAnnotationConstants.RESET
});
const selectByAnnotationTypeID = annotationTypeID => ({
  type: reportAnnotationConstants.SELECT_BY_TYPE_ID,
  data: {
    annotationTypeID
  }
});
const deleteSuccess = reportAnnotationID => ({
  type: reportAnnotationConstants.DELETE_SUCCESS,
  data: {
    reportAnnotationID
  }
});

// update error state
const deleteFailure = (reportAnnotationID, error) => ({
  type: reportAnnotationConstants.DELETE_FAILURE,
  data: {
    reportAnnotationID,
    error
  }
});
const serverDeleteAnnotation = id => async dispatch => {
  try {
    await ajax.remove(`/reportAnnotations/${id}`);
    dispatch(deleteSuccess(id));
    return dispatch(issueActions.showCancel());
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'reportAnnotation', deleteFailure.bind(this, id, ajax.getError(e)), serverDeleteAnnotation.bind(this, id), handleRedirect));
  }
};
const serverSaveIssue = issue => dispatcher => {
  if (issue.pendingChanges) {
    const issueVersion = issue.active && issue.active.content && issue.active.content.version || undefined;
    dispatcher(issueActions.serverSave(issueVersion, handleRedirect));
  }
};
const serverSave = (ann, retry = false, opts = undefined) => async (dispatcher, getState) => {
  // Preserve our (ann, retry, opts) shape on retry; factory binds extra positional args.
  const retryWithOpts = entityObject => serverSave(entityObject, true, opts);
  const response = await dispatcher(changeActions.serverSave(ann, retry, retryWithOpts, handleRedirect, opts));
  if (response && response.type === reportAnnotationConstants.SAVE_SUCCESS) {
    const {
      issue
    } = getState();
    return dispatcher(serverSaveIssue(issue));
  }
  return response;
};
const onServerSaveMergePatchesSuccess = (baseAnnotation, issueID) => (savedID, savedResponses) => dispatcher => {
  const [response] = savedResponses;
  const completeAnnotation = _objectSpread(_objectSpread({}, baseAnnotation), {}, {
    issue: {
      id: issueID,
      content: response.content
    }
  });
  // create new annotation and add it to the reportAnnotation list
  dispatcher(createAnnotations(completeAnnotation, 'issue'));
  // toggle toggle save success (pending = false)
  dispatcher(changeActions.saveSuccess(baseAnnotation.id, completeAnnotation));
  // queue server show for the issue now that it's stored in the db
  dispatcher(issueActions.serverShow(issueID));
};
const serverCreate = (annotations, type) => async dispatch => {
  const url = '/reportAnnotations/create';
  const updatedAnnotations = annotations.map(next => {
    const {
      baseAnnotation,
      typeAnnotation
    } = next;
    const typeSetAnnotation = baseAnnotation;
    // the `issue` annotation specific data is stripped out and handed to the merge patch endpoint
    if (type !== 'issue') {
      // in the UI, we treat ink and line annotations very differently, but from a data perspective,
      // they are the same annotation type. If the type is a `line`, we set it up to be an ink
      // annotation when passing to the server. In all other cases the annotation type is fine as is
      typeSetAnnotation[`${type === 'line' ? 'ink' : type}Annotation`] = typeAnnotation;
    }
    return typeSetAnnotation;
  });
  const annotationToSetActive = updatedAnnotations[updatedAnnotations.length - 1];

  // symbolically set action to saving - the last annotation created will be the `saving` annotation
  // which also means it will be the selected annotation once server save completes
  dispatch(changeActions.save(annotationToSetActive.id));
  try {
    // endpoint accepts an array of annotations
    await ajax.post(url, updatedAnnotations);

    // only supporting single issue annotation creation at this time
    if (type === 'issue' && updatedAnnotations.length === 1) {
      const {
        baseAnnotation,
        typeAnnotation
      } = annotations[0];
      const {
        id: issueID
      } = typeAnnotation;
      dispatch(issueActions.serverSaveMergePatches(issueID, [{
        entity: 'Issue',
        id: issueID,
        patch: typeAnnotation
      }],
      // creates issue patch
      onServerSaveMergePatchesSuccess(baseAnnotation, issueID)));
    } else if (['info', 'freeText', 'ink', 'line', 'highlight'].includes(type)) {
      // the ajax post above saves all annotations to server, now iterate over each annotation
      // and add them to the redux store. Then dispatch save success
      updatedAnnotations.forEach(annotation => dispatch(createAnnotations(annotation, type)));
      dispatch(changeActions.saveSuccess(annotationToSetActive.id, annotationToSetActive));
    }
  } catch (error) {
    dispatch(tokenErrorActions.handleError(error, 'reportAnnotation', changeActions.createFail.bind(this, error), serverCreate.bind(this, annotations, type), handleRedirect));
  }
};
const reportAnnotationActions = _objectSpread(_objectSpread({}, changeActions), {}, {
  selectByAnnotationTypeID,
  serverSave,
  onServerSaveMergePatchesSuccess,
  serverDeleteAnnotation,
  handleRedirect,
  serverCreate,
  reset
});
export default reportAnnotationActions;